<template>
  <div class="badInfoDetail">
    <el-card
      class="box-card"
      v-loading="loading"
      element-loading-text="数据正在加载中，请稍候"
    >
      <div class="back">
        <div></div>
        <el-button
          type="primary"
          icon="el-icon-arrow-left"
          size="small"
          @click="goBack"
          >返回</el-button
        >
      </div>
      <company-header
        :companyInfo="companyInfo"
        :scoreInfo="scoreInfo"
        v-if="activeName == 'first'"
      ></company-header>
      <manager-header
        :managerInfo="managerInfo"
        :dataInfoObj="dataInfoObj"
        :scoreInfo="scoreInfo"
        v-else
      ></manager-header>
      <good-and-bad-table
        :dataInfoObj="dataInfoObj"
        :applyContent="applyContent"
        :isGood="false"
        :deadlineObj="deadlineObj"
      ></good-and-bad-table>
    </el-card>
  </div>
</template>

<script>
import managerHeader from './components/managerHeader.vue';
import companyHeader from './components/companyHeader.vue';
import goodAndBadTable from './components/goodAndBadTable.vue';
import { CreditEvaQueryController } from '@/service/creditEvaQueryController/creditEvaQueryController.js';
import { CreditEvaResultController } from '@/service/creditEvaResultController/creditEvaResultController.js';
import { CreditEvaNoticeController } from '@/service/creditEvaNoticeController/creditEvaNoticeController.js';
export default {
  name: 'badInfoDetail',
  components: {
    goodAndBadTable,
    companyHeader,
    managerHeader,
  },
  data() {
    return {
      activeName: '',
      managerInfo: {},
      companyInfo: {},
      scoreInfo: {},
      dataInfoObj: {},
      deadlineObj: {},
      loading: false,
    };
  },
  created() {
    this.CreditEvaQueryController = new CreditEvaQueryController();
    this.CreditEvaResultController = new CreditEvaResultController();
    this.CreditEvaNoticeController = new CreditEvaNoticeController();
    this.activeName = this.$route.query.activeName;
    this.mob = this.$route.query.mob || '';
    this.orgCode = this.$route.query.orgCode || '';
    this.docCode = this.$route.query.docCode || '';
    this.applyContent = this.$route.query.applyContent
      ? decodeURIComponent(this.$route.query.applyContent)
      : '';
    if (this.activeName == 'first') {
      this.getCreditEvaInformationVO(2);
    } else {
      this.getCreditEvaInformationVO(1);
    }
    this.getResultDocDTOByApplyYwdbh();
    this.getNoticeRecordByApplyId();
  },
  methods: {
    // 获取物业企业信息 openId:String, token:String, mob:String, orgCode:String, type:String
    getCreditEvaInformationVO(type) {
      this.loading = true;
      this.CreditEvaQueryController.getCreditEvaInformationVO_builtBureauWebsite(
        this.mob,
        this.orgCode,
        type
      )
        .then((res) => {
          this.loading = false;
          if (type == 2) {
            this.companyInfo = res;
          } else {
            this.managerInfo = res;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    //  获取计分项
    getResultDocDTOByApplyYwdbh() {
      this.CreditEvaResultController.getResultDocDTOByApplyYwdbh_builtBureauWebsite(
        this.docCode
      )
        .then((res) => {
          if (res) {
            this.dataInfoObj = res;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    //  获取公示截止日期
    getNoticeRecordByApplyId() {
      this.CreditEvaNoticeController.getNoticeRecordByApplyId_builtBureauWebsite(
        this.docCode
      )
        .then((res) => {
          if (res) {
            this.deadlineObj = res;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 返回
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.badInfoDetail {
  .back {
    display: flex;
    justify-content: space-between;
  }
  width: 100%;
  height: 800px;
}
</style>
